<template>
    <!-- 购物车新版 -->
    <div class="app">
        <!-- <jycheader :navIndex="0"></jycheader> -->
        <jycheader></jycheader>
        <!-- <div style="width:100%;background-color:#f1f1f1;height:1.875rem"></div> -->
        <div class="sho_box">
            <div
                class="shopcart-bigbox"
                v-if="foodsFlag"
            >
                <div class="shopcart-box">
                    <div class="mycart-no-tips shopping-p dis">
                        <div>首页</div>
                        <div class="shopping-top"></div>
                        <div class="shopping-p dis">
                            <div style="width:18px"></div>购物车
                        </div>
                    </div>
                    <!----------------------->
                    <div class="shoppin-left-box" style="height:200px">
                        <div class="shoppin-left-he"></div>
                        <div class="shoppin-left-son" :class="CategoryTypeValue == 1?'shoppin-left-act':''" @click="tabTittleClick(1)">商品<span v-if="countOne > 0">({{countOne}})</span></div>
                        <!-- <div class="shoppin-left-he"></div>
                        <div class="shoppin-left-son" :class="CategoryTypeValue == 4?'shoppin-left-act':''" @click="tabTittleClick(4)">名小吃<span v-if="countFour > 0">({{countFour}})</span></div> -->
                        <div class="shoppin-left-he"></div>
                        <div class="shoppin-left-son" :class="CategoryTypeValue == 2?'shoppin-left-act':''" @click="tabTittleClick(2)">折扣<span v-if="countTwo > 0">({{countTwo}})</span></div>
                        <!-- <div class="shoppin-left-he"></div>
                        <div class="shoppin-left-son" :class="CategoryTypeValue == 3?'shoppin-left-act':''" @click="tabTittleClick(3)">积分<span v-if="countThree > 0">({{countThree}})</span></div> -->
                    </div>
                    <!----------------------->
                    <div
                        class="mycart-container"
                        style="margin-top:-200px"
                        v-if="nodataFlag"
                    >
                        <div class="mycart-container-item">
                            <div class="mycart-header-box">
                                <div class="mycart-index">
                                    <el-checkbox
                                        type="checkbox"
                                        ref="businessInp"
                                        @change="allTitleClick()"
                                        v-model="cartFlag"
                                    ></el-checkbox>
                                    <!--label="全选"-->
                                    <!-- <input type="checkbox" ref="businessInp" value="全选" @change="getBusinessWhole" v-model="cartFlag"> -->
                                </div>
                                <div
                                    class="mycart-product"
                                    style="text-align:left;width:6.6rem"
                                >本页全选</div>
                                <div
                                    class="mycart-product"
                                    style="text-align:left"
                                >商品信息</div>
                                <!-- <div class="mycart-foods-name">名字</div> -->
                                <div class="mycart-foods-price">单价</div>
                                <div class="mycart-foods-num">数量</div>
                                <div class="mycart-subtotal" style="width: 12.125rem;">小计（元）</div>
                                <div class="mycart-foods-delete">操作</div>
                            </div>
                            <div v-if="goodsList.length > 0">
                                <div
                                    v-for="(item2,index2) in goodsList"
                                    :key="index2"
                                >
                                    <div class="dis" style="margin: 40px 0 10px 0">
                                        <div class="mycart-item-index" style="width:2rem;margin: auto 0;">
                                            <el-checkbox
                                                @change="actTitleClick(index2)"
                                                v-model="item2.v_act"
                                            ></el-checkbox>
                                        </div>
                                        <div class="mycart-item-img" style="width:33.25rem;">{{item2.shopName}}</div>

                                    </div>
                                    <div
                                        class="mycart-foods-item"
                                        v-for="(item,index) in item2.shopCarList"
                                        :key="index" style="background: #FAFAFA;margin-left:1.5rem;padding:14px 0 28px 11px"
                                    >
                                        <div class="mycart-item-index">
                                            <el-checkbox
                                                @change="actTitleSonClick(index2)"
                                                v-model="item.v_act"
                                            ></el-checkbox>
                                            <!-- <input type="checkbox" checked="checked" v-model="itemFlag" /> -->
                                        </div>
                                        <!-- <div class="mycart-line"></div> -->
                                        <div class="mycart-item-img dis" style="width: 33.25rem;">
                                            <img
                                                :src="item.cover"
                                                alt="" style="width:80px;height:80px;border-radius:3px;margin:auto 0"
                                            >
                                            <div class="shopping-wid shopping-pad" style="width:auto">
                                                {{item.name}}
                                                &nbsp;&nbsp;&nbsp;<span :class="item.shopType == 1?'or-new-num-col':'or-new-num-col2'">{{item.shopTypeName}}</span><span class="or-new-num-col2" style="background:#ff8500;margin-left:10px" v-if="item.goodsType == 2">积分</span>
                                                <!-- <div v-if="item.goodsSize" class="good-size-p2">{{item.goodsSize}}</div><div v-else class="good-size-p2" style="color:#ffffff">1</div> -->
                                                <div class="all-com-p" style="margin: 12px 0 0 0;font-size:14px">
                                                    <span v-if="item.goodsComponent1">{{item.goodsComponent1}}</span>
                                                    <span v-if="item.goodsComponent1 && item.goodsSize"> / </span>
                                                    <span v-if="item.goodsSize">{{item.goodsSize}}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mycart-item-price shopping-pad" style="width:10.6875rem;height:80px;">
                                            <p v-if="item.shopType == 1" style="color:#FF6B30">¥{{item.price}}元<span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.integral}}积分</span></p>
                                            <div v-else-if="item.shopType == 2" style="color:#FF6B30">¥{{item.discountPrice}}元<span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.integral}}积分</span>&nbsp;<div style="text-decoration:line-through;color:#929292">¥{{item.price}}</div></div>
                                        </div>

                                        <div class="mycart-item-num shopping-pad" style="height:80px;">
                                            <div
                                                class="mysave-less"
                                                @click="cartLessClick(index2,index)"
                                            >-</div>
                                            <div class="mysave-input">
                                                <input
                                                    v-model="item.num"
                                                    type="text"
                                                    disabled="disabled"
                                                >
                                            </div>
                                            <div
                                                class="mysave-add"
                                                @click="cartAddClick(index2,index)"
                                            >+</div>
                                        </div>
                                        <!-- <div class="mycart-line"></div> -->
                                        <div v-if="item.shopType == 2" class="mycart-item-subtotal shopping-pad" style="width: 14.125rem;height:80px;color:#FF6B30">
                                            <span>￥{{item.allDiscountPrice}}元</span>
                                            &nbsp;<div style="text-decoration:line-through;color:#929292">¥{{item.allPrice}}</div>
                                        </div>
                                        <div v-else class="mycart-item-subtotal shopping-pad" style="width: 14.125rem;height:80px;color:#FF6B30">
                                            <span>￥{{item.allPrice}}元</span>
                                            <span v-if="item.goodsType == 2">&nbsp;/&nbsp;{{item.v_integralSum}}积分</span>
                                        </div>
                                        
                                        <!-- <div class="mycart-line"></div> -->
                                        <div class="mycart-item-delete shopping-pad" style="height:80px;"><span :data-id="item.id" @click="deletegoods(item.id)">删除</span></div>
                                    </div>
                                </div>
                                <div style="height:20px"></div>
                            </div>
                            <div v-else class="dis-cen">
                                <div style="height:100px"></div>
                                <img src="../../assets/image/iocn/gouwuche.png" />
                                <div class="shopping-p-title">暂无数据</div>
                                <div
                                    class="shopping-go"
                                    @click="shoppingGoClick"
                                >马上去购物</div>
                                <div style="height:100px"></div>
                            </div>
                        </div>

                        <div
                            v-if="nodataFlag"
                            class="dis-end"
                            style="width:100%"
                        >
                            <div class="mycart-page">
                                <div class="shopping-count-css">共{{pageNumber}}页 {{totalLength}}条记录</div>
                                <div class="mycart-page-index">首页</div>
                                <div class="list-page dis-end">
                                    <el-pagination
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :page-size="PageSize"
                                        layout="prev, pager, next"
                                        :total="totalLength"
                                    >
                                        <!--:current-page.sync="currentPage"-->
                                    </el-pagination>
                                </div>
                                <div class="mycart-page-index">末尾</div>
                                <div class="dis shopping-jump-input">
                                    <div class="shopping-count-css">跳转</div>
                                    <el-input
                                        style="width:2rem;margin-right:10px"
                                        v-model="PageNo"
                                        placeholder=""
                                        @input="jumpFn"
                                    ></el-input>
                                    <!--currentPage-->
                                    <div
                                        class="shopping-count-css"
                                        style="margin:auto 20px auto 10px"
                                    >页</div>
                                </div><!-- ??? 监听输入框 -->
                            </div>
                        </div>

                        <div class="shopping-footer">
                            <div
                                class="mycart-footer dis-between"
                                v-if="nodataFlag"
                            >
                                <div class="dis">

                                    <div
                                        class="mycart-index"
                                        style="margin:auto 0 auto 20px;"
                                    >
                                        <el-checkbox
                                            type="checkbox"
                                            ref="businessInp"
                                            @change="allTitleClick()"
                                            v-model="cartFlag"
                                        ></el-checkbox>
                                        <!--label="全选"-->
                                        <!-- <input type="checkbox" ref="businessInp" value="全选" @change="getBusinessWhole" v-model="cartFlag"> -->
                                    </div>
                                    <div
                                        class="mycart-product"
                                        style="width:70px;font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #646464;"
                                    >本页全选</div>

                                    <div
                                        class="mycart-btm-del"
                                        @click="delcart"
                                    >
                                        删除选中商品
                                    </div>

                                </div>
                                <div class="dis">
                                    <div class="mycart-top-right">
                                        已选择<span style="color:#D43737">{{actGoodShopArr.length}}</span>种商品&nbsp;&nbsp;合计(不含运费)
                                    </div>
                                    <div class="foods-factprice">
                                        <span>￥{{payprice}}</span>
                                        <span v-if="is_integral" style="color:#D9161C">&nbsp;&nbsp;/&nbsp;&nbsp;{{integralAllSum}}积分</span>
                                    </div>
                                    <div
                                        class="mycart-pay shopping-now-bac"
                                        :class="is_play?'shopping-jsact':''"
                                        @click="shortlyPay"
                                    >去结算</div>
                                </div>
                            </div>
                        </div>

                        <!-- <div
                            class="mycart-btm-box"
                            v-if="nodataFlag"
                        >
                            <div
                                class="mycart-btm-del"
                                @click="delcart"
                            >
                                删除选中商品
                            </div>
                            <div class="mycart-btm-info">
                                <div class="mycart-btm-shipping">运费：<span>￥{{sendprice}}</span></div>
                                <div class="mycart-btm-price">商品金额：<span>￥{{totalprice}}</span></div>
                            </div>
                        </div>
                        <div
                            class="foods-factprice"
                            v-if="nodataFlag"
                        >
                            应付金额：<span>￥{{payprice}}</span>
                        </div>
                        <div
                            class="mycart-footer"
                            v-if="nodataFlag"
                        >
                            <div class="mycart-page">
                                <div class="mycart-page-index">首页</div>
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="PageSize"
                                    layout="prev, pager, next, total,jumper"
                                    :total="totalLength"
                                >
                                </el-pagination>
                                <div class="gopage_index">确认</div>
                            </div>
                            <div
                                class="mycart-pay"
                                @click="shortlyPay"
                            >立即支付</div>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- 批量删除提示框 -->
            <el-dialog
                title="提示"
                :visible.sync="batchDeleteFlag"
                width="30%"
                center
            >
                <span>确定删除所选商品吗?</span>
                <span
                    slot="footer"
                    class="dialog-footer"
                >
                    <el-button @click="batchDeleteFlag = false">取 消</el-button>
                    <el-button
                        type="primary"
                        @click="batchDelete"
                    >确 定</el-button>
                </span>
            </el-dialog>
            <!-- 购物车没商品时展示 -->
            <div
                class="sho_cent"
                v-if="nofoodFlag"
            >
                <div class="mycart-no-tips shopping-p dis">
                    <div>首页</div>
                    <div class="shopping-top"></div>
                    <div class="shopping-p dis">
                        <div style="width:18px"></div>购物车
                    </div>
                </div>
                <div class="sho_cents">
                    <div class="dis-cen">
                        <img src="../../assets/image/iocn/gouwuche.png" />
                        <div class="shopping-p-title">暂无添加的商品</div>
                        <div
                            class="shopping-go"
                            @click="shoppingGoClick"
                        >马上去购物</div>
                    </div>
                    <!-- <img src="../../assets/image/img/购物车/gwc_ionc.jpg">
                    <div class="sho_centstest">
                        <div class="product-nofoods">您的购物车中没有商品,赶快行动吧 !</div>
                        <p>去 <span
                                style="color: #E9001C;"
                                @click="index"
                            >首页</span> 挑选喜爱的商品, 或 <span
                                style="color:#8CB91E;"
                                @click="login"
                            >登录</span> 访问收藏的商品</p>
                    </div> -->
                </div>
            </div>
        </div>
        <jycfooter></jycfooter>
    </div>
</template>

<script>
    import jycheader from "../header.vue"
    import jycfooter from "../bottom.vue"
    import { MessageBox } from "element-ui"
    const that = this;
    const token = '';
    export default
    {
        data()
        {
            return {
                batchDeleteFlag: false, //批量删除提示框状态
                centerDialogVisible: false, //单条商品删除提示框状态
                submitFlag: false,
                goodsNum: 1,

                nofoodFlag: false,
                // payFlag: false, //支付状态
                currentPage: 1,
                cartNum: 1,
                itemFlag: false, //单选
                cartFlag: false, //全选
                foodsFlag: true, //有无数据状态

                // gsflag: true, //工行支付
                // nyflag: false, //农行卡支付
                // wxflag: false, //微信支付
                // zfbflag: false, //支付宝支付

                goodsList: [], //购物车数据 页面呈现的数据
                PageNo: 1,
                PageSize: 3, //每页显示几条
                totalLength: 0, //数据总条数
                pageNumber: 0, // 共几页
                nodataFlag: false, //没有数据时隐藏操作按钮
                actData: [],
                chooseNum: 0, //已选择的商品数量
                business: [],
                delcartId: [], //购物车id
                chooseItem: [], //单选
                totalprice: 0,
                integralAllSum: 0,
                payprice: 0, //应付总金额
                sendprice: 0, //运费
                goodsPlayList: [], // 历史商品列表 用户选定数据
                is_play: false,
                is_integral: false,
                CategoryTypeValue: 1, //1普通 2折扣 3积分 4名小吃
                countOne: 0,
                countTwo: 0,
                countThree: 0,
                countFour: 0,
                actGoodShopArr: []
            }
        },
        components:
        {
            jycheader,
            jycfooter
        },
        created()
        {
            window.scroll(0, 0)
            if ( !localStorage.getItem( 'token' ) )
            {
                this.nofoodFlag = true;
                this.foodsFlag = false;
            }
            // this.$loading();
            this.authMarketAddressFn()
            
        },
        mounted()
        {
            // let payflag = localStorage.getItem('payflag');
            // this.payFlag = payflag;
        },
        methods:
        {
            // 新版购物车 +---------------------------------------------------------------------------------------------------------
            initGoodListFn(data) {
                for (let i = 0; i < data.length; i++) {
                    let a = Number( data[i].price ) * 100 * data[i].num
                    let b = Number( data[i].discountPrice ) * 100 * data[i].num
                    data[i]['allPrice'] = Number( a / 100 ).toFixed( 2 )
                    data[i]['allDiscountPrice'] = Number( b / 100 ).toFixed( 2 )
                    data[i]['v_act'] = false
                }
                return data
            },
            subtotalSumFn(data, val) {
                if (val) {
                    data.num = data.num + 1
                } else {
                    data.num = data.num - 1
                }
                let a = Number( data.price ) * 100 * data.num
                let b = Number( data.discountPrice ) * 100 * data.num
                data.allPrice = Number( a / 100 ).toFixed( 2 )
                data.allDiscountPrice = Number( b / 100 ).toFixed( 2 )
                return data
            },
            actTitleClick(idx) {
                this.goodsList[idx].shopCarList = this.shopCarListValFn(this.goodsList[idx].shopCarList, this.goodsList[idx].v_act)
                this.totalPriceFn()
            },
            shopCarListValFn(data, value) {
                for (let i = 0; i < data.length; i++) {
                    data[i].v_act = value
                }
                return data
            },
            actTitleSonClick(idx2) {
                let a = this.goodsList[idx2].shopCarList
                let b = []
                for (let i = 0; i < a.length; i++) {
                    if (a[i].v_act) b.push(1)
                }
                if (b.length == a.length) {
                    this.goodsList[idx2].v_act = true
                } else {
                    this.goodsList[idx2].v_act = false
                }
                this.totalPriceFn()
            },
            allTitleClick() {
                for (let i = 0; i < this.goodsList.length; i++) {
                    this.goodsList[i].v_act = this.cartFlag
                    this.goodsList[i].shopCarList = this.shopCarListValFn(this.goodsList[i].shopCarList, this.cartFlag)
                }
                this.totalPriceFn()
            },
            cartLessClick(idx2, idx) {
                if (this.goodsList[idx2].shopCarList[idx].num == 1) {
                    this.checkTips( "至少1件商品", 'warning' );
                    return
                }
                this.goodsList[idx2].shopCarList[idx] = this.subtotalSumFn(this.goodsList[idx2].shopCarList[idx])
                this.totalPriceFn()
            },
            cartAddClick(idx2, idx) {
                this.goodsList[idx2].shopCarList[idx] = this.subtotalSumFn(this.goodsList[idx2].shopCarList[idx], 1)
                this.totalPriceFn()
            },
            totalPriceFn() {
                let objArr = []
                let allPrice = 0
                this.is_play = false
                this.actGoodShopArr = []
                this.delcartId = []
                for (let i = 0; i < this.goodsList.length; i++) {
                    let a = this.goodsList[i].shopCarList
                    objArr = objArr.concat(a)
                }
                for (let j = 0; j < objArr.length; j++) {
                    if (objArr[j].v_act) {
                        this.is_play = true
                        this.actGoodShopArr.push(objArr[j])
                        this.delcartId.push(objArr[j].id)
                        allPrice = allPrice + Number( objArr[j].allPrice )
                    }
                }
                this.totalprice = allPrice.toFixed( 2 ); //商品金额
                this.payprice = ( allPrice + this.sendprice ).toFixed( 2 ); //应付金额
            },
            // +--------------------------------------------------------------------------------------------------------------------
            shoppingGoClick()
            {
                this.$router.push(
                {
                    path: "/"
                } )
            },
            // 新增逻辑代码 +---------------------------------------------------
            jumpFn()
            {
                // !!!
            },
            // +----------------------------------------
            authMarketAddressFn() {
                let that = this
                // if ( !localStorage.getItem('token') )
                // {
                //     this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                //     {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     } ).then( () =>
                //     {
                //         this.$router.push({path: '/login'})
                //     } ).catch( () =>
                //     {
                //         // ...
                //     } )
                //     return 1
                // }
                if (!JSON.parse( localStorage.getItem( 'marketActObj' )) || !JSON.parse( localStorage.getItem( 'AddressActObj' )) ) {
                    this.$confirm( '请选择收货地址及菜市场？', '提示',
                    {
                        confirmButtonText: '前往选择',
	                    showCancelButton: false,
                        showClose: false,
                        closeOnClickModal: false,
                        // cancelButtonText: '取消',
                        type: 'warning'
                    }).then( () =>
                    {
                        that.$router.push( { path: '/marketlist?num=1' } )
                    }).catch( () =>
                    {
                        // ...
                    })

                    return 1
                }
                this.shopcartList();
            },
            // +----------------------------------------
            unitPriceFn( data )
            {
                for ( let i = 0; i < data.length; i++ )
                {   
                    let allPriceNow = 0
                    if (data[i].shopType == 1) {
                        data[ i ][ 'v_minute_price' ] = Number( data[ i ].price ) * 100
                        allPriceNow = data[i].v_minute_price * data[i].num / 100
                    } else if(data[i].shopType == 2) {
                        data[ i ][ 'v_discountPrice' ] = Number( data[ i ].discountPrice ) * 100
                        allPriceNow = data[i].v_discountPrice * data[i].num / 100
                    }
                    
                    data[i]['allPrice'] = allPriceNow.toFixed(2)
                    data[i]['v_integralSum'] = data[i].integral * data[i].num
                    data[ i ][ 'v_pitch' ] = ''
                }

                return data
            },
            cartFn( id, val )
            {
                for ( let i = 0; i < this.goodsPlayList.length; i++ )
                {
                    let playId = this.goodsPlayList[ i ].id
                    if ( id === playId ) this.goodsPlayList[ i ].num = val
                }

                this.computersTotalPrice()
            },
            comparisonFn( data )
            {
                let oldData = this.goodsPlayList
                let optData = []
                let mergeData = []

                for ( let i = 0; i < data.length; i++ )
                {
                    let id = data[ i ].id
                    console.log( id )
                    data[ i ][ 'is_del' ] = false
                    for ( let j = 0; j < oldData.length; j++ )
                    {
                        let oldId = oldData[ j ].id
                        if ( id === oldId )
                        {
                            data[ i ].v_pitch = oldData[ j ].v_pitch
                            data[ i ].flag = oldData[ j ].flag
                            data[ i ].is_del = true
                        }
                    }
                }
                optData = Object.assign( [], data )
                for ( let z = optData.length - 1; z >= 0; z-- )
                {
                    if ( optData[ z ].is_del )
                    {
                        optData.splice( z, 1 );
                    }
                }

                if ( optData.length > 0 )
                {
                    mergeData = oldData.concat( optData )
                    this.goodsPlayList = mergeData
                }
                else
                {
                    this.goodsPlayList = oldData
                }
                this.goodsList = data

                this.extractFn()
                this.computersTotalPrice()
                return
            },
            extractFn()
            {
                let data = this.goodsPlayList
                let idData = []
                for ( let i = 0; i < data.length; i++ )
                {
                    if ( data[ i ].v_pitch ) idData.push( data[ i ].id )
                }
                this.delcartId = idData
            },
            computersTotalPrice()
            {
                console.log( '总计' )
                console.log( this.goodsPlayList )
                let count = []
                let actData = []
                for ( let i = 0; i < this.goodsPlayList.length; i++ )
                {
                    count.push( 1 )
                    if (this.goodsPlayList[ i ].shopType == 1) {
                        this.goodsPlayList[ i ][ 'v_summation' ] = this.goodsPlayList[ i ].v_minute_price * this.goodsPlayList[ i ].num
                    }else{
                        this.goodsPlayList[ i ][ 'v_summation' ] = this.goodsPlayList[ i ].v_discountPrice * this.goodsPlayList[ i ].num
                    }

                    this.goodsPlayList[ i ]['v_integralSum'] = this.goodsPlayList[ i ].integral * this.goodsPlayList[ i ].num

                    
                    if ( this.goodsPlayList[ i ].v_pitch ) actData.push( this.goodsPlayList[ i ] )
                }
                console.log( actData )

                if ( count.length === this.goodsPlayList.length )
                {
                    if ( actData.length > 0 )
                    {
                        this.actData = actData
                        this.chooseNum = actData.length
                        this.is_play = true

                        let newSummation = 0
                        let integralAllSum = 0
                        let integral_count = []
                        for ( let z = 0; z < actData.length; z++ )
                        {
                            newSummation = newSummation + actData[ z ].v_summation
                            integralAllSum = integralAllSum + actData[ z ].v_integralSum

                            if (actData[z].goodsType == 2) integral_count.push(1)
                        }
                        this.payprice = newSummation / 100
                        this.payprice = this.payprice.toFixed(2)
                        this.integralAllSum = integralAllSum

                        if (integral_count.length == actData.length) {
                            this.is_integral = true
                        } else {
                            this.is_integral = false
                        }
                    }
                    else
                    {
                        this.payprice = 0
                        this.chooseNum = 0
                        this.is_play = false
                    }
                }

            },
            // +---------------------------------------------------------------
            batchDelete()
            { //执行批量删除
                this.$loading();
                let params = {
                    ids: this.delcartId
                }
                this.$api.product.deleteGoods( params ).then( res =>
                {
                    this.batchDeleteFlag = false;
                    this.$loading().close();
                    if ( res.data.code == 0 )
                    {

                        // for ( let j = 0; j < this.delcartId.length; j++ )
                        // {
                        //     let valueId = this.delcartId[ j ]
                        //     for ( let i = 0; i < this.goodsPlayList.length; i++ )
                        //     {
                        //         let newid = this.goodsPlayList[ i ].id
                        //         if ( valueId === newid ) this.goodsPlayList.splice( i, 1 )
                        //     }
                        // }

                        this.shopcartList();
                        let name = '删除成功！';
                        this.checkTips( name, 'success' );
                    }
                    else
                    {
                        let name = res.data.message;
                        this.checkTips( name, 'warning' );
                    }
                } )
            },
            delcart()
            { //打开批量删除提示框
                if ( this.delcartId == '' )
                {
                    let name = '请选择需要删除的商品!';
                    this.checkTips( name, 'warning' );
                }
                else
                {
                    this.batchDeleteFlag = true;
                }
            },
            getBusinessWhole()
            { //点击全选
                if ( this.cartFlag )
                {
                    this.goodsList.forEach( val =>
                    {
                        val.flag = true
                    } )

                    for ( let i = 0; i < this.goodsList.length; i++ )
                    {
                        let id = this.goodsList[ i ].id
                        for ( let j = 0; j < this.goodsPlayList.length; j++ )
                        {
                            let playId = this.goodsPlayList[ j ].id
                            if ( id === playId )
                            {
                                this.goodsPlayList[ j ].v_pitch = true
                                this.goodsPlayList[ j ].flag = true
                            }
                        }
                    }
                    // this.getBusiness( this.cartFlag );
                }
                else
                {
                    this.goodsList.forEach( val =>
                    {
                        val.flag = false
                    } )

                    for ( let k = 0; k < this.goodsList.length; k++ )
                    {
                        let id = this.goodsList[ k ].id
                        for ( let z = 0; z < this.goodsPlayList.length; z++ )
                        {
                            let playId = this.goodsPlayList[ z ].id
                            if ( id === playId )
                            {
                                this.goodsPlayList[ z ].v_pitch = false
                                this.goodsPlayList[ z ].flag = false
                            }
                        }
                    }
                    // this.business = [];
                }

                this.extractFn()
                this.computersTotalPrice()

                // this.chooseNum = this.business.length;
                // this.getAllPrice( this.business )
            },
            //计算总价
            getAllPrice( chooseList )
            {
                let allPrice = 0
                chooseList.forEach( val =>
                {
                    allPrice = allPrice + Number( val.allPrice )
                } )
                this.totalprice = allPrice.toFixed( 2 ); //商品金额
                this.payprice = ( allPrice + this.sendprice ).toFixed( 2 ); //应付金额
            },
            getBusiness( flag )
            { //获取全部商品信息
                if ( flag )
                {
                    this.goodsList.forEach( ( res, index ) =>
                    {
                        this.delcartId.push( res.id );
                        this.business.push( res )
                    } )
                }
                else
                {
                    this.business = [];
                }
            },
            //单选
            getGoodsInfo( item, index )
            {
                console.log( item.flag )
                if ( item.flag )
                {
                    for ( let i = 0; i < this.goodsPlayList.length; i++ )
                    {
                        let newId = this.goodsPlayList[ i ].id
                        if ( item.id === newId )
                        {
                            this.goodsPlayList[ i ].v_pitch = true
                            this.goodsPlayList[ i ].flag = true
                        }
                    }
                }
                else
                {
                    for ( let z = 0; z < this.goodsPlayList.length; z++ )
                    {
                        let newId = this.goodsPlayList[ z ].id
                        if ( item.id === newId )
                        {
                            this.goodsPlayList[ z ].v_pitch = false
                            this.goodsPlayList[ z ].flag = false
                        }
                    }
                }

                this.extractFn()
                this.computersTotalPrice()
            },
            delete_ok( id )
            { //单条商品删除

            },
            async deletegoods( id )
            {
                //打开删除提示框
                this.centerDialogVisible = true;
                let ret = await MessageBox.confirm( "确定删除当前商品吗?" ).then( r => r ).catch( e => e );

                if ( ret == 'confirm' )
                {
                    let params = {
                        ids: [ id ]
                    }
                    this.$loading()
                    this.$api.product.deleteGoods( params ).then( res =>
                    {
                        if ( res.data.code == 0 )
                        {
                            this.centerDialogVisible = false;
                            this.$message(
                            {
                                message: '删除成功！',
                                type: 'success'
                            } )

                            for ( let i = 0; i < this.goodsPlayList.length; i++ )
                            {
                                let newid = this.goodsPlayList[ i ].id
                                if ( id === newid ) this.goodsPlayList.splice( i, 1 )

                            }

                            this.shopcartList();
                        }
                        else
                        {
                            this.centerDialogVisible = false;
                            this.$message(
                            {
                                message: '删除失败！',
                                type: 'warning'
                            } )
                        }
                        this.$loading().close();
                    } ).catch( e =>
                    {
                        this.$loading().close();
                    } )
                }
            },
            shopcartList()
            { //获取购物车列表数据
                let token = localStorage.getItem( 'token' );
                if ( token == '' || token == null )
                {
                    this.$message(
                    {
                        message: '登录后查看购物车商品！',
                        type: 'warning'
                    } )
                }
                else
                {
                    this.$loading();
                    let params = {
                        PageNo: this.PageNo,
                        PageSize: this.PageSize,
                        CategoryType: this.CategoryTypeValue
                    }
                    this.$api.product.shopcartList( params ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            this.nodataFlag = true;
                            const { data } = res.data.result
                            // [新版] +--------------------------------------------------------
                            for (let i = 0; i < data.length; i++) {
                                data[i]['v_act'] = false
                                data[i].shopCarList = this.initGoodListFn(data[i].shopCarList)
                            }
                            this.goodsList = data
                            // [旧版购物车] +-----------------------------------------
                            // this.goodsList = data.map( item =>
                            // {
                            //     return {
                            //         ...item,
                            //         allPrice: Number( item.price ).toFixed( 2 ),
                            //         flag: false
                            //     }
                            // } )
                            // +------------------------
                            // let resListData = this.unitPriceFn( this.goodsList )
                            // if ( this.goodsPlayList.length == 0 )
                            // {
                            //     this.goodsList = this.goodsPlayList = resListData
                            // }
                            // else
                            // {
                            //     this.comparisonFn( resListData )
                            // }
                            // +------------------------
                            this.totalLength = res.data.result.totalCount;

                            this.pageNumber = this.totalLength / this.PageSize
                            let pageNumberStr = this.pageNumber.toString()
                            if ( this.pageNumber < 1 ) this.pageNumber = 1
                            if ( pageNumberStr.indexOf( "." ) != -1 )
                            {
                                this.pageNumber = pageNumberStr.substr( 0, 1 )
                                this.pageNumber = Number( this.pageNumber ) + 1
                            }

                            // if ( res.data.result.totalCount == 0 )
                            // {
                            //     // this.nofoodFlag = true;
                            //     // this.foodsFlag = false;
                            // }
                            // [补充] +----------------------------------------------------
                            if (this.CategoryTypeValue == 1) {
                                this.countOne = res.data.result.totalCount
                            }
                            if (this.CategoryTypeValue == 2) {
                                this.countTwo = res.data.result.totalCount
                            }
                            if (this.CategoryTypeValue == 3) {
                                this.countThree = res.data.result.totalCount
                            }
                            if (this.CategoryTypeValue == 4) {
                                this.countFour = res.data.result.totalCount
                            }
                            this.tabCountValueFn()
                        }
                        else
                        {
                            this.$message(
                            {
                                message: res.data.message,
                                type: "warning"
                            } )
                        }
                    } )
                }
            },
            // +-----------------------------------------------------------------------------------------------------------------
            immediatelyPay()
            {
                this.submitFlag = true;
            },
            checkTips( name, type )
            { //用户提示
                this.$message(
                {
                    message: name,
                    type: type
                } )
            },
            shortlyPay()
            {
                let is_show = false
                for (let i = 0; i < this.actGoodShopArr.length; i++) {
                    if (this.actGoodShopArr[i].shopType == 1) {
                        this.actGoodShopArr[i][ 'v_minute_price' ] = Number( this.actGoodShopArr[i].price ) * 100
                        this.actGoodShopArr[i][ 'v_summation' ] = this.actGoodShopArr[i].v_minute_price * this.actGoodShopArr[i].num
                    } else if (this.actGoodShopArr[i].shopType == 2) {
                        is_show = true
                        this.actGoodShopArr[i][ 'v_discountPrice' ] = Number( this.actGoodShopArr[i].discountPrice ) * 100
                        this.actGoodShopArr[i][ 'v_summation' ] = this.actGoodShopArr[i].v_discountPrice * this.actGoodShopArr[i].num
                    }
                }
                if (is_show) {
                    this.checkTips( "折扣商品暂时不能购买!", 'warning' );
                    return
                }
                if (this.actGoodShopArr.length == 0) return
                // +----------------------------------------------------------------
                localStorage.setItem( 'goodInfo', JSON.stringify( this.actGoodShopArr ) );
                this.$router.push(
                {
                    path: '/orderinfo'
                } )

                // +-------------------------------------------------------------------------
                // if ( this.chooseNum > 0 )
                // {
                //     let is_show = false
                //     // !修复小计中未保留两位小数
                //     this.actData.map((item) => {
                //         if(item.shopType == 1) {
                //             item.v_minute_price = item.v_minute_price.toFixed(2)
                //             item.v_summation = item.v_summation.toFixed(2)
                            
                //             item.v_minute_price = Number(item.v_minute_price)
                //             item.v_summation = Number(item.v_summation)

                //         } else if (item.shopType == 2) {
                //             is_show = true
                //             item.v_discountPrice = item.v_discountPrice.toFixed(2)
                //             item.v_summation = item.v_summation.toFixed(2)

                //             item.v_discountPrice = Number(item.v_discountPrice)
                //             item.v_summation = Number(item.v_summation)
                //         }
                //     })

                //     if (is_show) {
                //         this.checkTips( "折扣商品暂时不能购买!", 'warning' );
                //         return
                //     }
                //     // +----------------------------------------------------------------
                //     localStorage.setItem( 'goodInfo', JSON.stringify( this.actData ) );
                //     this.$router.push(
                //     {
                //         path: '/orderinfo'
                //     } )
                // }
                // else
                // {
                //     this.checkTips( "请至少选择一件商品!", 'warning' );
                // }

                // let goodsList = this.business;
                // if ( !this.cartFlag && this.business.length == 0 )
                // {
                //     let name = "请至少选择一件商品!";
                //     this.checkTips( name, 'warning' );
                // }
                // else
                // {
                //     localStorage.setItem( 'goodInfo', JSON.stringify( goodsList ) );
                //     this.$router.push(
                //     {
                //         path: '/orderinfo'
                //     } )
                // }
            },
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                console.log( `当前页: ${val}` );
                this.PageNo = val;
                this.shopcartList();
                this.business = [];
                this.cartFlag = false;
            },
            cartLess( item, index )
            {
                if ( item.num > 1 )
                {
                    item.num--;
                    if (this.goodsList[index].shopType == 1) {
                        this.$set( this.goodsList[ index ], 'allPrice', ( this.goodsList[ index ].price * item.num ).toFixed( 2 ) )
                    } else if (this.goodsList[index].shopType == 2) {
                        this.$set( this.goodsList[ index ], 'allPrice', ( this.goodsList[ index ].discountPrice * item.num ).toFixed( 2 ) )
                    }
                    let list = this.goodsList.filter( val =>
                    {
                        return val.flag
                    } )
                    this.getAllPrice( list );
                    let params = {
                        id: item.id,
                        num: item.num,
                        ShopGoodsId: item.shopGoodsId
                    }
                    this.$api.product.updatecartNum( params ).then( res =>
                    {
                        console.log( res )
                        // +---------------------------------------------------
                        this.cartFn( item.id, item.num )
                    } )
                }
                else
                {
                    let name = '至少选择一件商品！';
                    this.checkTips( name, 'warning' );
                }
            },
            cartAdd( item, index )
            {
                item.num++;
                if (this.goodsList[ index ].shopType == 1) {
                    this.$set( this.goodsList[ index ], 'allPrice', ( this.goodsList[ index ].price * item.num ).toFixed( 2 ) )
                }else if (this.goodsList[ index ].shopType == 2) {
                    this.$set( this.goodsList[ index ], 'allPrice', ( this.goodsList[ index ].discountPrice * item.num ).toFixed( 2 ) )
                }
                
                console.log( item.num )
                let list = this.goodsList.filter( val =>
                {
                    return val.flag
                } )

                this.getAllPrice( list );

                let params = {
                    id: item.id,
                    num: item.num,
                    ShopGoodsId: item.shopGoodsId
                }
                // 修改商品数量
                this.$api.product.updatecartNum( params ).then( res =>
                {
                    console.log( res )
                    // +---------------------------------
                    this.cartFn( item.id, item.num )
                } )
            },
            continue_shopping()
            { //继续购物
                this.$router.push(
                {
                    path: '/'
                } )
            },
            index()
            { //跳转首页
                this.$router.push(
                {
                    path: '/'
                } )
            },
            login()
            { //跳转登录页
                this.$router.push(
                {
                    path: '/login'
                } )
            },
            tabTittleClick(val) {
                this.cartFlag = false
                this.CategoryTypeValue = Number(val)

                this.actGoodShopArr = []
                this.delcartId = []
                this.is_play = false
                this.totalprice = 0
                this.payprice = 0
                this.shopcartList()
                this.tabCountValueFn()
            },
            tabCountValueFn() {
                let params = {
                    PageNo: this.PageNo,
                    PageSize: this.PageSize,
                    CategoryType: this.CategoryTypeValue
                }
                if (this.CategoryTypeValue == 1) {
                    params.CategoryType = 2
                    this.$api.product.shopcartList( params ).then( res => {
                        if ( res.data.code == 0 ) {
                            this.countTwo = res.data.result.totalCount
                            params.CategoryType = 3
                            this.$api.product.shopcartList( params ).then( res => {
                                if ( res.data.code == 0 ) {
                                    this.countThree = res.data.result.totalCount
                                    params.CategoryType = 4
                                    this.$api.product.shopcartList( params ).then( res => {
                                        if ( res.data.code == 0 ) {
                                            this.countFour = res.data.result.totalCount
                                        }
                                    })
                                }
                            })
                        }
                    })
                } else if (this.CategoryTypeValue == 2) {
                    params.CategoryType = 1
                    this.$api.product.shopcartList( params ).then( res => {
                        if ( res.data.code == 0 ) {
                            this.countOne = res.data.result.totalCount
                            params.CategoryType = 3
                            this.$api.product.shopcartList( params ).then( res => {
                                if ( res.data.code == 0 ) {
                                    this.countThree = res.data.result.totalCount
                                    params.CategoryType = 4
                                    this.$api.product.shopcartList( params ).then( res => {
                                        if ( res.data.code == 0 ) {
                                            this.countFour = res.data.result.totalCount
                                        }
                                    })
                                }
                            })
                        }
                    })
                } else if (this.CategoryTypeValue == 3) {
                    params.CategoryType = 1
                    this.$api.product.shopcartList( params ).then( res => {
                        if ( res.data.code == 0 ) {
                            this.countOne = res.data.result.totalCount
                            params.CategoryType = 2
                            this.$api.product.shopcartList( params ).then( res => {
                                if ( res.data.code == 0 ) {
                                    this.countTwo = res.data.result.totalCount
                                    params.CategoryType = 4
                                    this.$api.product.shopcartList( params ).then( res => {
                                        if ( res.data.code == 0 ) {
                                            this.countFour = res.data.result.totalCount
                                        }
                                    })
                                }
                            })
                        }
                    })
                } else if (this.CategoryTypeValue == 4) {
                    params.CategoryType = 1
                    this.$api.product.shopcartList( params ).then( res => {
                        if ( res.data.code == 0 ) {
                            this.countOne = res.data.result.totalCount
                            params.CategoryType = 3
                            this.$api.product.shopcartList( params ).then( res => {
                                if ( res.data.code == 0 ) {
                                    this.countThree = res.data.result.totalCount
                                    params.CategoryType = 2
                                    this.$api.product.shopcartList( params ).then( res => {
                                        if ( res.data.code == 0 ) {
                                            this.countTwo = res.data.result.totalCount
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            }
        },
        computed:
        {

        }
    }
</script>

<style scoped="scoped">
    .pay-code {
        width: 9.375rem;
        height: 9.375rem;
        border: 1px solid #FF0000;
        border-radius: 10px;
        margin: 1.5rem auto 0 auto;
    }

    .paytype-item img:nth-of-type(1) {
        width: 5.75rem;
        margin-right: 1rem;
    }

    .paytype-item img:nth-of-type(2) {
        width: 3.4375rem;
        margin-right: 1rem;
    }

    .paytype-item img:nth-of-type(3) {
        width: 3.5625rem;
    }

    .paytype-item img {
        height: 1.125rem;
    }

    .paytype-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.875rem;
    }

    .pay-code-tips {
        margin-top: 3.125rem;
        color: #191919;
        font-size: 17px;
        text-align: center;
    }

    .pay-code-price span {
        color: #37A115;
        font-weight: bold;
        font-size: 2.125rem;
    }

    .pay-code-price {
        font-size: 24px;
        color: #191919;
        margin-top: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pay-code-top p:nth-of-type(2) {
        font-size: 28px;
        cursor: pointer;
    }

    .pay-code-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #191919;
        font-size: 1rem;
    }

    .pay-code-content {
        width: 29.375rem;
        height: 27.5rem;
        background-color: #FFFFFF;
        border-radius: 0.625rem;
        border: 4px solid #B3B3B3;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0 0.4375rem;
    }

    .pay-code-box {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    .submit-box {
        width: 65.625rem;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 3.125rem;
    }

    .goods-price-right span {
        color: #D43737;
        font-size: 1.5rem;
        font-weight: bold;
    }

    .goods-price-right {
        color: #333333;
        font-size: 18px;
        font-weight: 400;
    }

    .goods-price-left p:nth-of-type(2) {
        margin-left: 2.9375rem;
    }

    .goods-price-left span {
        color: #333333;
    }

    .goods-price-left p {
        color: #999999;
        font-size: 0.875rem;
        font-weight: 400;
    }

    .goods-price-left {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .goods-price-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 0.875rem;
    }

    .goods-line {
        width: 100%;
        height: 1px;
        background-color: #9A9A9A;
        margin-top: 0.625rem;
    }

    .goods-cz span {
        display: inline-block;
        width: 0.625rem;
        height: 0.625rem;
        border-top: 1px solid #999999;
        border-right: 1px solid #999999;
        transform: rotate(-45deg);
        margin-left: 0.625rem;
        margin-bottom: 2px;
    }

    .goods-cz {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        text-align: center;
        margin: auto;
        color: #666666;
        font-size: 1rem;
        cursor: pointer;
    }

    .goods-count-box span {
        font-size: 22px;
        color: #CD3E3B;
    }

    .goods-count-box {
        width: 13.625rem;
        color: #999999;
        font-size: 1rem;
        text-align: center;
    }

    input {
        -moz-appearance: none !important;
        outline: none !important;
        -moz-outline: none !important;
    }

    .goods-num-box input {
        width: 1.875rem;
        height: 1.25rem;
        text-align: center;
        font-size: 14px;
        color: #000000;
        margin: 0 0.625rem;
    }

    .goods-jian {
        margin-left: 0.3125rem;
    }

    .goods-jian,
    .goods-add {
        width: 0.875rem;
        height: 0.875rem;
        border: 1px solid #D8D8D8;
        line-height: 0.75rem;
        text-align: center;
        cursor: pointer;
    }

    .goods-num-box {
        width: 14.75rem;
        height: 3.125rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px dashed #E2E2E2;
        color: #999999;
        font-size: 1rem;
    }

    .goods-price {
        width: 12.75rem;
        height: 3.125rem;
        text-align: center;
        line-height: 3.125rem;
        color: #999999;
        font-size: 1rem;
        border-right: 1px dashed #E2E2E2;
    }

    .goods-name {
        width: 13.0625rem;
        height: 3.125rem;
        color: #737373;
        font-size: 1rem;
        font-weight: 400;
        line-height: 3.125rem;
        text-align: center;
        border-right: 1px dashed #E2E2E2;
    }

    .goods-img img {
        width: 3.125rem;
        height: 3.125rem;
    }

    .goods-img {
        width: 11.125rem;
        height: 3.125rem;
        text-align: center;
        border-right: 1px dashed #E2E2E2;
    }

    .goods-info-item {
        width: 100%;
        height: 3.125rem;
        display: flex;
        align-items: center;
        margin-bottom: 1.875rem;
    }

    .myfoods-pay-box {
        width: 75rem;
        margin: auto;
        padding-left: 1.25rem;
        padding-top: 1rem;
    }

    .order-info {
        font-size: 1.125rem;
        color: #333333;
        font-weight: 400;
    }

    .soon-pay-btn {
        width: 13.0625rem;
        height: 3.125rem;
        text-align: center;
        line-height: 3.125rem;
        color: #FFFFFF;
        font-size: 18px;
        background-color: #D43737;
        margin-left: 2.6875rem;
        margin-top: 2.5rem;
        cursor: pointer;
    }

    .ok_img {
        width: 0.5625rem;
        height: 0.5625rem;
        position: absolute;
        top: 0.125rem;
        right: 0.125rem;
    }

    .choose-type {
        position: absolute;
        top: 0;
        right: 0;
        width: 0;
        height: 0;
        border-top: 1.4375rem solid #37A115;
        border-left: 1.5625rem solid transparent;
    }

    .choose-paytype-item {
        position: relative;
        cursor: pointer;
        margin-right: 2.1875rem;
    }

    .choose-paytype-item,
    .choose-paytype-item img:nth-of-type(2) {
        width: 8.75rem;
        height: 3.0625rem;
    }

    .choose-paytype-box {
        width: 65.625rem;
    }

    .choose-payType-tips {
        color: #4B4B4B;
        font-size: 16px;
        font-weight: 400;
        margin-top: 1.5625rem;
        margin-bottom: 2.1875rem;
        padding-left: 1rem;
    }

    .address-more {
        color: #979797;
        font-size: 12px;
        font-weight: 400;
        padding-left: 1.25rem;
        cursor: pointer;
    }

    .receiver-detail-address {
        color: #4D4D4D;
        font-size: 16px;
        font-weight: 400;
        padding-left: 2.5rem;
        margin-bottom: 1.25rem;
    }

    .info-tips-right {
        color: #37A115;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .info-tips-left {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
    }

    .receiver-info-tips {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.25rem;
    }

    .receiver-info-box {
        width: 62.375rem;
        height: 8.3125rem;
        border: 1px solid #989898;
        margin-left: 1rem;
        margin-top: 0.8125rem;
        padding: 0.625rem 1.25rem 0 1.25rem;
    }

    .myfoods-user-box {
        margin-top: 2.5rem;
        padding-left: 1rem;
    }

    .myfoods-user-box {
        color: #4B4B4B;
        font-size: 1rem;
        font-weight: 400;
    }

    .mycart-container-item {
        width: 100%;
        height: auto;
        min-height: 25rem;
        background-color: #ffffff;
        padding: 0 20px;
    }

    .gopage_index {
        width: 2.5rem;
        height: 27px;
        text-align: center;
        line-height: 25px;
        margin-left: 5px;
        cursor: pointer;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #97989D;
        background: #FFFFFF;
        border: 1px solid #E3E3E3;
        border-radius: 5px;
    }

    .mycart-pay {
        width: 140px;
        height: 58px;
        text-align: center;
        line-height: 58px;
        background-color: #D43737;
        color: #FFFFFF;
        font-size: 18px;
        cursor: pointer;
    }

    .mycart-footer {
        /* display: flex;
        align-items: center;
        justify-content: space-between; */
        margin-top: 0rem;
    }

    .mycart-page-index {
        width: 2.5rem;
        height: 34px;
        text-align: center;
        line-height: 34px;
        font-size: 12px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #97989D;
        background: #FFFFFF;
        border: 1px solid #E3E3E3;
        border-radius: 5px;
        cursor: pointer;
    }

    .mycart-page {
        /* width: 60%; */
        display: flex;
        align-items: center;
        margin: 40px 0
    }

    .mycart-page>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #07762E;
        color: #FFF;
    }

    .mycart-page>>>.el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        margin: 0 5px;
        background-color: #ffffff;
        color: #97989D;
        min-width: 30px;
        border-radius: 2px;
    }

    .foods-factprice span {
        color: #D43737;
        font-size: 24px;
    }

    .foods-factprice {
        color: #333333;
        font-size: 18px;
        font-weight: 400;
        text-align: right;
        padding-right: 78px;
        line-height: 58px;
        /* margin-top: 3.75rem; */
    }

    .mycart-btm-price {
        margin-left: 2.5rem;
    }

    .mycart-btm-info span {
        color: #333333;
    }

    .mycart-btm-info {
        display: flex;
        align-items: center;
        color: #999999;
        font-size: 14px;
        font-weight: 400;
    }

    .mycart-btm-del {
        /* width: 7.3125rem; */
        /* height: 1.5625rem; */
        /* text-align: center; */
        line-height: 58px;
        /* border: 1px solid #627D4D; */
        cursor: pointer;
        color: #999999;
        font-size: 14px;
        margin-left: 20px
    }

    .mycart-btm-box {
        width: 100%;
        display: flex;
        height: 1.875rem;
        align-items: center;
        justify-content: space-between;
        margin-top: 1.25rem;
        padding-left: 1.875rem;
        padding-right: 1.25rem;
    }

    .mycart-item-delete {
        width: 9rem;
        height: 170px;
        /* margin: auto; */
        text-align: right;
        padding-right: 24px;
        cursor: pointer;
    }

    .mycart-item-subtotal {
        width: 8.125rem;
        height: 170px;
        color: #BC0000;
    }

    .mycart-item-num {
        width: 13.125rem;
        height: 170px;
        display: flex;
        /* align-items: center; */
        justify-content: center;
    }

    .mycart-item-price p:nth-of-type(1) {
        color: #BC0000;
    }

    .mycart-item-price p:nth-of-type(2) {
        color: #999999;
        font-size: 12px;
        margin-top: 2px;
    }

    .mycart-item-price {
        width: 7.6875rem;
        height: 170px
            /* display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center; */
    }

    .mycart-item-name {
        width: 8.9375rem;
    }

    .mycart-item-img img {
        width: 6.125rem;
        height: 6.125rem;
        margin: 36px 0
    }

    .mycart-item-img {
        width: 32.25rem;
        /* padding-top: 0.125rem; */
    }

    .mycart-line {
        width: 1px;
        height: 3.125rem;
        background-color: #E2E2E2;
    }

    .mycart-foods-item {
        text-align: center;
        display: flex;
        align-items: center;
        /* height: 5.57rem; */
        border-bottom: 1px solid #f5f5f5;
        color: #333333;
        font-size: 14px;
        font-weight: 400;
    }

    .mycart-foods-delete {
        width: 9rem;
        text-align: right;
        padding-right: 24px;
    }

    .mycart-subtotal {
        width: 8.1875rem;
    }

    .mycart-foods-num {
        width: 13.1875rem;
    }

    .mycart-foods-price {
        width: 7.75rem;
    }

    .mycart-foods-name {
        width: 9rem;
    }

    .mycart-product {
        width: 26rem;
        line-height: 58px;
    }

    .mycart-item-index {

        width: 2.625rem;
        text-align: left;
    }

    .mycart-item-index input {
        border: 1px solid red;
        width: 20px;
        height: 20px;
    }

    .mycart-index {
        width: 2rem;
        text-align: left;
        /* padding-left: 1.8rem */
    }

    .mycart-index input {
        width: 1.25rem;
        height: 1.25rem;
        background-color: #FFFFFF;
        color: #000000;
    }

    .mysave-input input:disabled {
        background-color: #FFFFFF;
    }

    .mysave-input input {
        /* border: 1px solid #CFCFCF; */
        border: none;
        border-top: 1px solid #CFCFCF;
        border-bottom: 1px solid #CFCFCF;
        outline: none;
    }

    .mysave-input {
        /* margin: 0 5px; */
        margin: 0
    }

    .mysave-input,
    .mysave-input input {
        width: 2.25rem;
        height: 1.3125rem;
        text-align: center;
        color: #333333;
        font-size: 14px;
        margin-top:0.5px
    }

    .mysave-less,
    .mysave-add {
        width: 1.3125rem;
        height: 1.3125rem;
        /* border-radius: 50%; */
        border: 1px solid #CFCFCF;
        text-align: center;
        line-height: 1.1rem;
        color: #333333;
        font-size: 16px;
        cursor: pointer;
        background-color: #F8F8F8;
        margin-top: 1px
    }

    .mycart-index,
    .mycart-product,
    .mycart-foods-name,
    .mycart-foods-price,
    .mycart-foods-num,
    .mycart-subtotal {
        border-right: 1px solid #ffffff;
    }

    .mycart-header-box {
        display: flex;
        align-items: center;
        width: 100%;
        /* height: 2.625rem; */
        background-color: #ffffff;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        text-align: center;
        margin-top: 0.5rem;
        border-bottom: 1px solid #f5f5f5;
        /* padding: 20px 0; */
        box-sizing: border-box;
    }

    .mycart-top-right span {
        color: #333333;
        margin: 0 5px;
    }

    .mycart-top-right {
        color: #999999;
        font-size: 14px;
        font-weight: 400;
        line-height: 58px;
        margin-right: 23px;
    }

    .mycart-top-left span {
        display: inline-block;
        width: 6px;
        height: 24px;
        background-color: #82BA55;
        margin-right: 0.625rem;
    }

    .mycart-top-left {
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
    }

    .mycart-top-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.125rem;
    }

    .shopcart-tips p:nth-of-type(1) {
        color: #333333;
        font-size: 18px;
        font-weight: 400;
        cursor: pointer;
    }

    .shopcart-tips p:nth-of-type(2) {
        color: #999999;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
    }

    .shopcart-tips {
        padding-left: 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .shopcart-box {
        width: 75rem;
        height: auto;
        margin: auto;
        padding-top: 0.5rem;
    }

    .shopcart-bigbox {
        width: 100%;
        height: auto;
        min-height: 49.6875rem;
        border-bottom: 1px solid #E7E7E7;
        ;
    }

    .product-nofoods {
        font-size: 24px;
        color: #595757;
        font-weight: 400;
    }

    .mycart-no-tips {
        width: 75rem;
        margin: auto;
        /* padding-left: 1rem; */
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 34px;
    }

    .sho_box {
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
    }

    .sho_cent {
        width: 100%;
        height: 32.4375rem;
        background: #F2F2F2;
        position: relative;
        padding-top: 0.5rem;
    }

    .sho_cents {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /* padding-top: 5rem; */
    }

    .sho_cents img {
        width: 14rem;
        height: 11.625rem;

    }

    .sho_centstest h3 {
        font-size: 24px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #595757;
    }

    .sho_centstest p {
        font-size: 14px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        color: #999999;
        margin-top: 0.5rem;
    }

    .sho_centstest span {
        cursor: pointer;
    }

    .sho_centstest {
        margin-top: 4.375rem;
        margin-left: 1.875rem;
    }

    .shopping-p {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #434343;
        line-height: 34px;
    }

    .shopping-now-bac {
        background-color: #C1C1C1
    }

    .shopping-jsact {
        background-color: #D9161C;
    }

    .list-page>>>.el-pagination .btn-prev {
        padding-right: 12px;
        padding-left: 12px;
        width: 2rem;
        margin-right: 8px;
        color: #97989D
    }

    .list-page>>>.el-pagination .btn-next {
        padding-left: 12px;
        padding-right: 12px;
        width: 2rem;
        /* margin-left: 8px; */
        color: #97989D
    }

    .shopping-jump-input>>>.el-input__inner {
        height: 34px;
        width: 2.3rem;
        text-align: center;
        padding: 0 5px
    }

    @import '../../assets/style/base.css';
</style>
<style>
    .mycart-page .el-pager li.active+li {
        border-left: 1px solid #DDDDDD;
    }

    .mycart-page .el-pagination__total {
        margin-left: 10px;
    }

    .mycart-page .el-pager li {
        width: 1.875rem;
        height: 27px;
        border: 1px solid #DDDDDD;
        padding: 0;
        min-width: 1.875rem;
        line-height: 1.5625rem;
        border-radius: 2px;
        margin-right: 5px;
        color: #999999;
    }

    .mycart-page .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
        border-color: #E5E5E5;
    }

    .mycart-page .el-pagination button:hover {
        color: #5D6C52;
    }

    .mycart-page .btn-prev {
        margin-right: 5px;
    }

    .mycart-page .el-pager li.active {
        color: #ffffff;
        border-color: #07762E;
        background-color: #069338;
    }

    .mycart-page .btn-prev,
    .mycart-page .btn-next {
        width: 54px;
        height: 27px;
        border: 1px solid #DDDDDD;
        color: #999999;
        text-align: center;
        padding: 0;
    }

    /* .mycart-page .el-icon-arrow-left:before {
        content: '<<上一页';
    }

    .mycart-page .el-icon-arrow-right:before {
        content: '下一页>>';
    } */

    .mycart-index .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #37A115;
        border-color: #37A115;
    }

    .mycart-index .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #37A115;
    }

    .mycart-index .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #666666;
        font-size: 14px;
    }

    .mycart-item-index .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #37A115;
    }

    .mycart-item-index .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #37A115;
        border-color: #37A115;
    }

    .mycart-item-index .el-checkbox__input.is-checked+.el-checkbox__label {
        color: #666666;
        font-size: 14px;
    }
</style>